export enum NoDataState {
  notAvailable = 'notAvailable',
  noData = 'noData',
  nothingHere = 'nothingHere',
  dataProcessing = 'dataProcessing',
  table = 'table',
  noCampaignMapping = 'noCampaignMapping'
}
